"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT () {
        return ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT;
    },
    get ENCOUNTER_HISTORY_PAGE_SIZE_MAX () {
        return ENCOUNTER_HISTORY_PAGE_SIZE_MAX;
    },
    get EncounterHistoryItemSchema () {
        return EncounterHistoryItemSchema;
    },
    get PLAN_EXCERPT_MAX_LENGTH () {
        return PLAN_EXCERPT_MAX_LENGTH;
    },
    get PatientEncounterHistoryQuerySchema () {
        return PatientEncounterHistoryQuerySchema;
    },
    get PatientEncounterHistoryResponseSchema () {
        return PatientEncounterHistoryResponseSchema;
    },
    get planExcerpt () {
        return planExcerpt;
    }
});
const _zod = require("zod");
const _encounterdetail = require("./encounter-detail");
const _icd10search = require("../icd10/icd10-search");
const isoDateTime = ()=>_zod.z.string().datetime({
        offset: true
    });
const PLAN_EXCERPT_MAX_LENGTH = 160;
const ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT = 10;
const ENCOUNTER_HISTORY_PAGE_SIZE_MAX = 50;
const ELLIPSIS = '…';
const DANGLING_TAIL = /[\s.,;:!?\-–—]+$/;
function planExcerpt(plan) {
    if (plan === null || plan === undefined) {
        return '';
    }
    const normalized = plan.replace(/\s+/g, ' ').trim();
    if (normalized.length <= PLAN_EXCERPT_MAX_LENGTH) {
        return normalized;
    }
    let head = normalized.slice(0, PLAN_EXCERPT_MAX_LENGTH);
    const endsOnWordBoundary = normalized.charAt(PLAN_EXCERPT_MAX_LENGTH) === ' ';
    if (!endsOnWordBoundary) {
        const lastSpace = head.lastIndexOf(' ');
        if (lastSpace > 0) {
            head = head.slice(0, lastSpace);
        } else if (/[\uD800-\uDBFF]$/.test(head)) {
            // A hard cut must not leave half of a surrogate pair behind.
            head = head.slice(0, -1);
        }
    }
    const tidied = head.replace(DANGLING_TAIL, '');
    if (tidied.length === 0) {
        return `${head}${ELLIPSIS}`;
    }
    return `${tidied}${ELLIPSIS}`;
}
const PatientEncounterHistoryQuerySchema = _zod.z.object({
    page: _zod.z.coerce.number().int().min(1).default(1),
    pageSize: _zod.z.coerce.number().int().min(1).max(ENCOUNTER_HISTORY_PAGE_SIZE_MAX).default(ENCOUNTER_HISTORY_PAGE_SIZE_DEFAULT)
}).strict();
const EncounterHistoryItemSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    encounterNo: _zod.z.string(),
    startedAt: isoDateTime(),
    signedAt: isoDateTime(),
    chiefComplaint: _zod.z.string(),
    planExcerpt: _zod.z.string().max(PLAN_EXCERPT_MAX_LENGTH + ELLIPSIS.length),
    primaryDiagnosis: _icd10search.Icd10SearchItemSchema.nullable(),
    additionalDiagnosisCount: _zod.z.number().int().min(0),
    provider: _encounterdetail.EncounterUserRefSchema
}).strict();
const PatientEncounterHistoryResponseSchema = _zod.z.object({
    items: _zod.z.array(EncounterHistoryItemSchema),
    page: _zod.z.number().int().min(1),
    pageSize: _zod.z.number().int().min(1).max(ENCOUNTER_HISTORY_PAGE_SIZE_MAX),
    total: _zod.z.number().int().min(0)
}).strict();
